


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { Event } from '../store/models';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Actions as EventsActions} from '@/modules/events/store/actions';
import { eventsModuleName } from '@/modules/events/store';
const eventsModule = namespace(eventsModuleName);

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class EventListItem extends Vue {

  @Prop() private event!: Event;

@eventsModule.Action(EventsActions.DELETE_EVENT) private deleteEvent!: (eventId: number) => void;

  private editEventLink: any = { name: 'eventEdit', params: { eventId: this.event.id } };

  private deleteEventClicked(eventId: number, eventName: string, eventDateTime: Date) {

    (this as any).$bvModal.msgBoxConfirm(
      `Czy na pewno chcesz usunąć wydarzenie "${eventName}"
        z ${this.$moment(eventDateTime).format('YYYY-MM-DD HH:mm')}?`, {
      title: 'Potwierdź usunięcie',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'danger',
      okTitle: 'Usuń',
      cancelTitle: 'Anuluj',
      footerClass: 'p-2',
      hideHeaderClose: false,
      // centered: true,
    })
    .then((confirmed: boolean) => {
      if (confirmed) {
        this.deleteEvent(eventId);
      }
    });
  }

  private inFuture(event: Event): boolean {
    return new Date(event.eventDateTime) > new Date();
  }

  private getVariantClass(): string {
    if (this.inFuture(this.event)) {
      return 'list-group-item-accent-success';
    } else {
      return 'list-group-item-accent-danger';
    }
  }
}
